import { v4 as uuidv4 } from 'uuid';
import useScript from 'hooks/useScript';

const useInitSardine = () => {
  const isProduction = process.env.NODE_ENV === 'production';
  const sardineHost = isProduction ? 'api.sardine.ai' : 'api.dev.sardine.ai';

  const initializeSardine = function () {
    window._Sardine.createContext({
      clientId: isProduction
        ? process.env.REACT_APP_SARDINE_CLIENT_ID
        : '9a4ce3c1-c171-4b84-acf6-c565e5787bc9',
      sessionKey: uuidv4(),
      flow: 'account-creation',
      environment: isProduction ? 'production' : 'development',
      parentElement: document.body,
      // called when sardine generates/restores deviceID for given device.
      onDeviceResponse: function (data) {
        return data;
      },
    });
  };

  useScript({
    src: `https://${sardineHost}/assets/loader.min.js`,
    async: true,
    onload: initializeSardine,
  });
};

export default useInitSardine;
